import { render, staticRenderFns } from "./interfaceSetupSonSon.vue?vue&type=template&id=1c97ae04&"
import script from "./interfaceSetupSonSon.vue?vue&type=script&lang=js&"
export * from "./interfaceSetupSonSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports